module.exports = __webpack_public_path__ + "img/photo-0070.30c64469.jpg";